import type { GetAttorneyClientsResponse } from "../../../api/src/users/attorney/clients/route";
import {
  getAppointments,
  getNextAppointment,
  getTodayAppointments,
} from "../pages/attorney/appointments/utils";
import {
  getAttorneyServiceCount,
  getThisWeekAppointments,
  getVisibleClients,
} from "../pages/attorney/dashboard/utils";
import { useMemo } from "react";

interface UseGetAttorneyDashboardDataProps {
  clients: GetAttorneyClientsResponse;
  attorneyId: string;
}

const useAttorneyDashboardData = ({
  clients,
  attorneyId,
}: UseGetAttorneyDashboardDataProps) => {
  const totalAppointments = useMemo(
    () => getAppointments(clients, attorneyId),
    [clients, attorneyId],
  );
  const visibleClientsCount = useMemo(
    () => getVisibleClients(totalAppointments),
    [totalAppointments],
  );
  const { qaCount, representationCount } = useMemo(
    () => getAttorneyServiceCount(totalAppointments),
    [totalAppointments],
  );
  const todayAppointments = useMemo(
    () => getTodayAppointments(totalAppointments),
    [totalAppointments],
  );
  const thisWeekAppointments = useMemo(
    () => getThisWeekAppointments(totalAppointments),
    [totalAppointments],
  );
  const nextAppointment = useMemo(
    () => getNextAppointment(todayAppointments),
    [todayAppointments],
  );

  return {
    totalAppointments,
    visibleClientsCount,
    qaCount,
    representationCount,
    todayAppointments,
    thisWeekAppointments,
    nextAppointment,
  };
};

export default useAttorneyDashboardData;
